import { child, ref, update } from "firebase/database";
import { httpsCallable } from "firebase/functions";
import { useObjectVal } from "react-firebase-hooks/database";

import { fbDatabase, fbFunctions } from "../firebase";
import { userTransform, UserData } from "./user.types";

export * from "./user.types";

export type BoardExportData = {
  board: { title: string; description: string | null };
  sessions: { session: number; createdDate: unknown }[];
  categories: { category: number; session: number; title: string; description: string }[];
  items: { session: number; category: number; text: string }[];
  notes: { session: number; text: string }[];
};

export type UserExportData = {
  exportDate: string;
  profile: { uid: string; name: string };
  boards: BoardExportData[];
};

const userOptions = {
  keyField: 'uid',
  transform: userTransform,
};

function refUsers() { return ref(fbDatabase, 'users') } // private, no need for all users
export function refUser(userUid: string) { return child(refUsers(), userUid) }
export function refUserBoards(userUid: string) { return child(refUser(userUid), 'boardUids') }

export function useUser(userUid: string) { return useObjectVal<UserData>(userUid ? refUser(userUid) : undefined, userOptions) }

/** Read only the public `name` field — works for any authenticated user, even non-self. */
export function useUserName(userUid: string) {
  return useObjectVal<string>(userUid ? child(refUser(userUid), 'name') : undefined);
}

export const editUser: (userUid: string, name: string) => Promise<void> = async (userUid, name) => {
  await update(refUser(userUid), { name });
}

export async function exportUserData(): Promise<UserExportData> {
  const fn = httpsCallable<void, UserExportData>(fbFunctions, "exportUserData");
  const result = await fn();
  return result.data;
}

export async function deleteUserAccount(): Promise<boolean> {
  const fn = httpsCallable<void, { success: boolean }>(fbFunctions, "deleteUserAccount");
  const result = await fn();
  return result.data.success;
}
